<template>
    <div class="container-list">
        <div class="common-page common-head">
            <div class="common-page common-head-title">
                <i class="icon-tr-other"></i>
               {{$route.query.id ?'巡查人员编辑' : '新增巡查人员'}}
            </div>
        </div>
        <el-form ref="form" :model="form" label-width="110px" :rules="rule">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="登录账号" prop="user_name">
                        <el-input v-model="form.user_name" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
<!--                <el-col :span="6">-->
<!--                    <el-form-item label="登录密码" prop="login_pass">-->
<!--                        <el-input v-model="form.login_pass" placeholder="请输入" ></el-input>-->
<!--                    </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="6">
                    <el-form-item label="真实姓名" prop="nick_name">
                        <el-input v-model="form.nick_name" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="所属单位" prop="company_num">
                        <!-- <el-autocomplete
                            class="inline-input"
                            v-model="form.company_num"
                            :fetch-suggestions="querySearch"
                            value-key="c_name"
                            placeholder="请输入内容"
                            @select="keywordChange"
                        ></el-autocomplete> -->
                        <!-- <el-input
                            v-model="form.company_num"
                            @input="keywordChange($event)"       
                            clearable   
                            /> -->
                            <!-- <el-select v-model="form.affiliatedUnit" filterable placeholder="请选择">
              <el-option v-for="item in compOption" :key="item.key" :label="item.label" :value="item.key"></el-option>
            </el-select> -->
                        <el-select v-model="form.company_num" filterable placeholder="请选择" @change="unitChange">
                            <el-option v-for="item in units" :key="item.c_company_num" :label="item.c_name" :value="item.c_company_num"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="6">
                    <el-form-item label="" prop="role_key">
                        <el-select v-model="form.role_key" placeholder="请选择">
                            <el-option v-for="item in roles" :label="item.role_value" :value="item.role_key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <el-col :span="6">
                    <el-form-item label="手机号" prop="phonenumber">
                        <el-input v-model="form.phonenumber" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="6">
                    <el-form-item label="电子邮箱" prop="user_email">
                        <el-input v-model="form.user_email" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :span="6">
                    <el-form-item label="修改密码" prop="login_pass">
                        <el-input type="password" v-model="form.login_pass" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                       <el-col :span="6">
                    <el-form-item label="巡查区域" prop="xc_point" >
                        <!-- <el-input type="password" v-model="form.login_pass" placeholder="请输入" ></el-input> -->
                        <el-select v-model="form.xc_point" multiple="multiple">
                                <el-option v-for="item in pointList" :label="item.x_company_area" :value="item.x_company_id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                 <el-col :span="6">
                    <el-form-item label="标签类型" prop="login_pass">
                        <!-- <el-input type="password" v-model="form.login_pass" placeholder="请输入" ></el-input> -->
                        <el-select v-model="form.xc_nfc" >
                                <!-- <el-option v-for="item in pointList" :label="item.x_company_area" :value="item.x_company_id"></el-option> -->
                                <el-option  label="二维码标识" :value="'1'"></el-option> 
                                <el-option  label="NFC标识" :value="'2'"></el-option>
                                 <el-option label="二维码和NFC" :value="'3'"></el-option>

                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="6" v-if="isWenwu==1">
                    <el-form-item label="巡查类型" prop="inspectionType">
                        <el-select v-model="form.inspectionType" >
                                <el-option  label="自查" :value="4"></el-option> 
                                <el-option  label="巡查" :value="1"></el-option>
                                 <el-option label="巡查和自查" :value="5"></el-option>

                        </el-select>
                    </el-form-item>
                </el-col> -->

            </el-row>
            <!-- <el-row :gutter="20">
                <el-col :span="6" v-if="isWenwu==1">
                    <el-form-item label="检查角色" prop="inspectionRole">
                        <el-select v-model="form.inspectionRole" >
                                <el-option  label="检查组长" value="1"></el-option> 
                                <el-option  label="检查人员" value="2"></el-option>

                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row> -->

            <div class="btn-box center">
                <el-button  type="primary"  @click="onSubmit">保存</el-button>

                <el-button  type="primary" class="ml20" @click="$router.back()">返回</el-button>
            </div>

        </el-form>
    </div>
</template>

<script>
    import {addUser} from '../../api/user'
    export default {
        data(){
            return{
                form:{
                    user_name:'',
                    nick_name:'',
                    phonenumber:'',
                    login_pass:'',
                    xc_nfc:'3',
                    inspectionType: '',
                    xc_point:[],
                    xc_area:'',
                    company_num:'',
                    inspectionRole:''
                    
                },
                isWenwu:'',
                pointList:[],
                roles:[],
                rule:{
                    user_name: { required: true, message: '请填写账号', trigger: 'change' },
                    company_num: { required: true, message: '请选择所属单位', trigger: 'change' },
                    role_key:{ required: true, message: '请选择分配角色', trigger: 'change' },
                    inspectionType:{ required: true, message: '请选择巡查类型', trigger: 'change' },
                    inspectionRole:{ required: true, message: '请选择检查角色', trigger: 'change' }
                },
                units:[],
                playUnits:[]

            }
        },
     async   created(){
            this.form.inspectionType = this.$route.query.inspection
            this.isWenwu=this.$route.query.inspection
            this.$get('/user/roleandcompany').then(res=>{
                this.roles = res.data.role
                this.units = res.data.company
             
            })
            // console.log(1);
            var url = this.isWenwu==1 ? 'xuncha/xunchaareadetail' : '/xuncha/xunchaareadetailWenWu'
            console.log(this.$store.state.user,'natureId');
         
            
            if(this.$route.query.id){
             await   this.$post('/user/edituser',{user_id:this.$route.query.id}).then(res=>{
                    console.log(res,4444);
                    this.form = res.data.list[0]
                    this.$set(this.form,'xc_point',this.form.xc_area ? this.form.xc_area.split(',') : [])
                console.log(this.form.company_num,11111);

                })
            }
            // console.log(2);

                console.log(this.form.company_num,222222);
                //  if (this.$store.state.user.userInfo.natureId==3) {
                    await   this.$post(url,{c_company_num:this.form.company_num||this.$store.state.user.company.cCompanyNum}).then(res=>{
                    this.pointList = res.data
                })
            // }
           
        },
        methods:{
            keywordChange(keywords){
                // this.playUnits=this.units.filter((item,index)=>{
                //     if(item.c_name.indexOf(keywords)!=-1){
                //         return item
                //     }
                // })
                console.log(keywords,33333333333);
                this.$post('/xuncha/xunchaareadetail',{c_company_num:keywords.c_company_num}).then(res=>{
                    console.log(res);
                    this.pointList = res.data
                    this.form.xc_point=''
                })

            },
            querySearch(queryString, cb) {
                console.log(queryString, cb);
                var suggestions = this.units;
                var results = queryString ? suggestions.filter((item,index)=>{return item.c_name.indexOf(queryString)!=-1}) : suggestions;
                console.log(results);
                // 需要调用 callback 来返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return suggestion => {
                    return (suggestion.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            changeFile(file, fileList){
                log(file, fileList)
            },
            unitChange(){
                var url = this.isWenwu==1 ? '/xuncha/xunchaareadetail' : '/xuncha/xunchaareadetailWenWu'
                console.log(this.form.company_num,2222);
                this.$post(url,{c_company_num:this.form.company_num}).then(res=>{
                    console.log(res);
                    this.pointList = res.data
                    this.form.xc_point=''
                })

            },
            onSubmit() {
                if(this.form.xc_point.length>0){
                    this.form.xc_area = this.form.xc_point.join(',')

                }else{
                    this.form.xc_area =''
                }

                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.form.status = 1
                        this.save()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            save(){
            //  if(!this.form.xc_point.length){
            //      this.$message.warning("请选择巡查区域")
            //      return
            //  }

                let loading = this.$loading({background: 'rgba(0, 0, 0, 0.6)'})
                let api = this.$route.query.id ? '/user/editsaveuser' : '/patrol/addxcperson';
                this.$post(api,this.form).then(res=>{
                    // this.$message.success('保存成功')
                    this.$message({
									message: "保存成功",
									type: 'success',
									duration: 700,
								});
                    loading.close()
                }).catch(err=>{
                    loading.close()
                })

            }
        }
    }
</script>

<style scoped>
 ::v-deep .el-select__tags-text {
  display: inline-block;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* background-color: #f4f4f5; */
  /* max-width: 5%; */
}
::v-deep .el-icon-close {
    vertical-align:middle;
    margin-bottom:12px
} 
/* ::v-deep .el-tag__close {
    vertical-align:middle
}
::v-deep .el-select{
    width: 20%;
} */
::v-deep .el-tag.el-tag--info {
    /* background-color: #f4f4f5; */
}
</style>